module.exports = __webpack_public_path__ + "img/benefit03.74e2bb71.png";